import React from "react";
import { useNavigate } from "react-router";
import { dateToString } from "~/utils/formatter";
import Empty from "../Empty";
import "~/assets/sass/pages/dashboard/dashboard-alarm.scss";
import { PaginationIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";

const Alarm = ({ alarmList }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<article className="item alarm">
			<div className="title-wrap">
				<h2 className="item-title">{t("pages.DashboardPage.Alarm.item-title")}</h2>
				<button
					type="button"
					className="btn-more"
					onClick={() => navigate("/alarm/list")}
				>
					<PaginationIcon />
				</button>
			</div>
			{alarmList?.length > 0 ? (
				<ul className="alarm-list">
					{alarmList.map((alarm, index) => (
						<li className="alarm-item" key={index}>
							<p className="alarm-content">{alarm.title}</p>
							<span className="alarm-date">
								{dateToString(alarm.regDate, "yyyy-MM-dd")}
							</span>
						</li>
					))}
				</ul>
			) : (
				<Empty message={t("pages.DashboardPage.Alarm.Empty")} />
			)}
		</article>
	);
};

export default Alarm;
